import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "diff-added",
  "use": "diff-added-usage",
  "viewBox": "0 0 448 512",
  "content": "<symbol viewBox=\"0 0 448 512\" id=\"diff-added\"><path d=\"M256 160h-64v64h-64v64h64v64h64v-64h64v-64h-64v-64zM416 32H32C16 32 0 48 0 64v384c0 16 16 32 32 32h384c16 0 32-16 32-32V64c0-16-16-32-32-32zm-32 368c0 8-8.5 16-16 16H80c-9 0-16-6-16-16V112c0-8 8-16 16-16h288c7.5 0 16 8 16 16v288z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/diff-added.svg
// module id = TGj7
// module chunks = 1